function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1981 16.9952C23.3504 16.1475 21.9465 16.2549 21.2375 17.2216L20.1304 18.7313C19.4215 19.6981 18.0181 19.8059 17.1703 18.9582C15.9351 17.723 14.2242 16.012 12.9035 14.6914C11.5829 13.3707 9.87189 11.6598 8.63669 10.4246C7.78895 9.57681 7.89681 8.1734 8.8636 7.46442L9.45389 7.03154C10.9041 5.96807 11.0651 3.8622 9.7935 2.59059L8.06232 0.859408C6.91644 -0.286469 5.05861 -0.286469 3.91273 0.859408L1.14634 3.6258C-0.381499 5.15364 -0.382419 7.62983 1.14542 9.15766C3.57392 11.5862 7.1252 15.1374 9.79131 17.8036C12.4574 20.4697 16.0087 24.021 18.4372 26.4495C19.965 27.9773 22.4412 27.9764 23.9691 26.4485L27.4271 22.9905C28.191 22.2266 28.191 20.9881 27.4271 20.2242L24.1981 16.9952Z",
  fill: "currentColor"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Phone.787cc272.svg";
export { ForwardRef as ReactComponent };